import React from 'react'
import './style.scss'
import tradingViewImg from '../../../assets/images/trading-view.png'

function DownloadBox() {
  return (
    <div className='download-box'>
   

   <img src={tradingViewImg}  alt='' />

        <button className='gradient-border-btn'>Download</button>
    </div>
  )
}

export default DownloadBox